import { cn, Text } from "@aurem/ui";
import { useI18n } from "providers/I18nProvider";
import type { FC } from "react";

import { MessageStatusEnum } from "types";
import { formatTimestamp } from "utils/dates";
import { ThreadMessage } from "..";
import { ChatErrorDisplay } from "./ChatErrorDisplay";

export const UserMessage: FC<{
  message: ThreadMessage;
  onRetry?: () => void;
  variant?: "panel" | "fullscreen";
}> = ({ message, onRetry, variant = "panel" }) => {
  const { t, language } = useI18n();

  return (
    <div className="flex flex-col space-y-2 ">
      <div className="flex flex-col items-end space-y-1">
        <div
          className={cn(
            /* eslint-disable-next-line @aurem/tailwind-rtl */
            `relative bg-neutral-500/10 rounded-2xl rounded-br-none rtl:rounded-bl-none rtl:rounded-br-2xl p-5 flex flex-col`,
            variant === "panel" ? "max-w-[85%]" : "max-w-[60%]",
          )}
        >
          <Text size="sm" className="text-neutral-500">
            {message.content}
          </Text>
        </div>
        {message.createdAt && (
          <Text size="sm" className="text-neutral-500/50 flex justify-end">
            {formatTimestamp(message.createdAt, language)}
          </Text>
        )}
      </div>

      {message.status === MessageStatusEnum.Failed && (
        <div className="flex justify-start">
          <ChatErrorDisplay
            errorMetadata={message.errorMetadata}
            retryCount={message.retryCount}
            onRetry={onRetry}
          />
        </div>
      )}

      {message.status === MessageStatusEnum.Canceled && (
        <div className="flex justify-start">
          <div className="max-w-[85%]">
            <Text size="sm" weight="medium" className="text-danger-800">
              {`${t("apps.admin.chatAI.messages.errors.cancel.summary")} - ${t(
                "apps.admin.chatAI.messages.errors.cancel.reasoning",
              )}`}
            </Text>
          </div>
        </div>
      )}
    </div>
  );
};
